import React from "react";
import { Alert, Container } from "react-bootstrap";

export default function EmptyState({
  message,
  icon = "ℹ️",
  variant = "info",
  className = ""
}) {
  return (
    <Alert variant={variant} className={className}>
      <div className="d-flex align-items-center">
        <span style={{ fontSize: "1.5rem" }} className="me-3">
          {icon}
        </span>
        <div>
          <strong>{message}</strong>
        </div>
      </div>
    </Alert>
  );
}
